export default {
  UPDATE_MENU_LIST: 'MENU/UPDATE_MENU_LIST',
  UPDATE_SEARCH_TEXT: 'MENU/UPDATE_SEARCH_TEXT',
  RESET_SEARCH_TEXT: 'MENU/RESET_SEARCH_TEXT',
  UPDATE_SEARCH_HISTORY: 'MENU/UPDATE_SEARCH_HISTORY',
};
